"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSecondaryCommoditiesItems = exports.getSecondaryCommoditiesByName = exports.getSecondaryCommodities = exports.getPrimaryCommoditiesItems = exports.getAnnualCargoCommodities = void 0;
const annualCargoCommodity_class_1 = require("./annualCargoCommodity.class");
const utils_1 = require("@loadsure/utils");
const commodities_annual_cargo_json_1 = __importDefault(require("../commodities-annual-cargo.json"));
;
let commodities;
const getAnnualCargoCommodities = () => {
    if (!commodities) {
        commodities = annualCargoCommodity_class_1.AnnualCargoCommodity.fromObj(commodities_annual_cargo_json_1.default);
    }
    return commodities;
};
exports.getAnnualCargoCommodities = getAnnualCargoCommodities;
const getPrimaryCommoditiesItems = () => exports.getAnnualCargoCommodities().primary.map((commodity) => new utils_1.Item(commodity.name, commodity.name));
exports.getPrimaryCommoditiesItems = getPrimaryCommoditiesItems;
const getSecondaryCommodities = (id, allSecondary) => exports.getAnnualCargoCommodities().getSecondaryCommodities(id, allSecondary);
exports.getSecondaryCommodities = getSecondaryCommodities;
const getSecondaryCommoditiesByName = (name) => exports.getAnnualCargoCommodities().getSecondaryCommoditiesByName(name);
exports.getSecondaryCommoditiesByName = getSecondaryCommoditiesByName;
const getSecondaryCommoditiesItems = (primaryName) => exports.getSecondaryCommoditiesByName(primaryName).map((commodity) => new utils_1.Item(commodity.name, commodity.name));
exports.getSecondaryCommoditiesItems = getSecondaryCommoditiesItems;
//# sourceMappingURL=index.js.map